// src/store/slices/geocercasSlice.js
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import GeocercaService from 'services/GeocercaService';

export const fetchGeocercas = createAsyncThunk(
    'geocercas/fetchAll',
    async (params, { rejectWithValue }) => {
        try {
            return await GeocercaService.getAll(params);
        } catch (err) {
            return rejectWithValue(err.response?.data?.message || 'Error al cargar geocercas');
        }
    }
);

export const createGeocerca = createAsyncThunk(
    'geocercas/create',
    async (data, { rejectWithValue }) => {
        try {
            return await GeocercaService.create(data);
        } catch (err) {
            return rejectWithValue(err.response?.data?.errors || err.response?.data?.message);
        }
    }
);

export const updateGeocerca = createAsyncThunk(
    'geocercas/update',
    async ({ id, data }, { rejectWithValue }) => {
        try {
            return await GeocercaService.update(id, data);
        } catch (err) {
            return rejectWithValue(err.response?.data?.errors || err.response?.data?.message);
        }
    }
);

export const deleteGeocerca = createAsyncThunk(
    'geocercas/delete',
    async (id, { rejectWithValue }) => {
        try {
            await GeocercaService.remove(id);
            return id;
        } catch (err) {
            return rejectWithValue(err.response?.data?.message || 'Error al eliminar');
        }
    }
);

export const updateGeocercaEstado = createAsyncThunk(
    'geocercas/updateEstado',
    async ({ id, activa }, { rejectWithValue }) => {
        try {
            return await GeocercaService.updateEstado(id, activa);
        } catch (err) {
            return rejectWithValue(err.response?.data?.message || 'Error al actualizar estado');
        }
    }
);

export const asignarGeocercaEmpleados = createAsyncThunk(
    'geocercas/asignarEmpleados',
    async ({ id, empleadoIds }, { rejectWithValue }) => {
        try {
            return await GeocercaService.asignarEmpleados(id, empleadoIds);
        } catch (err) {
            return rejectWithValue(err.response?.data?.message || 'Error al asignar empleados');
        }
    }
);

const geocercasSlice = createSlice({
    name: 'geocercas',
    initialState: {
        list: [],
        pagination: { current: 1, pageSize: 15, total: 0 },
        loading: false,
        error: null,
    },
    reducers: {
        clearGeocercasError: (state) => { state.error = null; },
    },
    extraReducers: (builder) => {
        builder
            .addCase(fetchGeocercas.pending, (state) => { state.loading = true; state.error = null; })
            .addCase(fetchGeocercas.fulfilled, (state, action) => {
                state.loading = false;
                state.list = action.payload.data;
                state.pagination = {
                    current: action.payload.meta.current_page,
                    pageSize: action.payload.meta.per_page,
                    total: action.payload.meta.total,
                };
            })
            .addCase(fetchGeocercas.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload;
            })
            .addCase(createGeocerca.fulfilled, (state) => { state.loading = false; })
            .addCase(updateGeocerca.fulfilled, (state) => { state.loading = false; })
            .addCase(deleteGeocerca.fulfilled, (state, action) => {
                state.list = state.list.filter((g) => g.id !== action.payload);
            })
            .addCase(updateGeocercaEstado.fulfilled, (state, action) => {
                const updated = action.payload.geocerca;
                if (updated) {
                    state.list = state.list.map((g) => (g.id === updated.id ? updated : g));
                }
            });
    },
});

export const { clearGeocercasError } = geocercasSlice.actions;
export default geocercasSlice.reducer;
